import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

export default function Item({ data }) {
    const { id, beginDate, closeDate, delivery, opportunity, state } = data;
    return (
        <tr>
            <td>{id}</td>
            <td>
                {moment(beginDate).isValid() ? moment(beginDate).format('DD.MM.YY') : 'Не указано'}
                <br />
                {moment(closeDate).isValid() ? moment(closeDate).format('DD.MM.YY') : 'Не указано'}
            </td>
            <td>{moment(closeDate).isValid() ? moment(closeDate).fromNow() : 'Не указано'}</td>
            <td>{delivery || 'Не указано'}</td>
            <td>{state || 'Не указано'}</td>
            {/*<td className="text-center">*/}
            {/*    <div className="ellipse ellipse--100" />*/}
            {/*</td>*/}
            {/*<td className="text-center">*/}
            {/*    <div className="ellipse ellipse--50" />*/}
            {/*</td>*/}
            <td className="text-right">{opportunity} руб.</td>
            <td className="text-right">
                <Link className="table__link-arrow" to={`/orders/${id}/`}>
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L7 7L0.999999 13" stroke="#CC0514" />
                    </svg>
                </Link>
            </td>
        </tr>
    );
}
